import DeleteSupplier from './DeleteSupplier';

export default DeleteSupplier;